export const addMeetingValidate = (meetingInfo, date, time, invitedPeople) => {

    const errors = {}

    if (!meetingInfo.title.trim()) {
        errors.title = "لطفا عنوان جلسه را وارد کنید"
    } else {
        delete errors.title
    }

    if (!meetingInfo.manager.trim()) {
        errors.manager = "لطفا رئیس جلسه را وارد کنید"
    } else {
        delete errors.manager
    }

    if (!meetingInfo.supervisor.trim()) {
        errors.supervisor = "لطفا ناظر را وارد کنید"
    } else {
        delete errors.supervisor
    }

    if (!meetingInfo.meetingResponsible.trim()) {
        errors.meetingResponsible = "لطفا مسول صورت جلسه را وارد کنید"
    } else {
        delete errors.meetingResponsible
    }

    if (!meetingInfo.meetingLocation.trim()) {
        errors.meetingLocation = "لطفا مکان جلسه را وارد کنید"
    } else {
        delete errors.meetingLocation
    }

    if (!meetingInfo.description.trim()) {
        errors.description = "لطفا توضیحات را وارد کنید"
    } else {
        delete errors.description
    }

    if (!meetingInfo.meetingOrder.trim()) {
        errors.meetingOrder = "لطفا دستور جلسه را وارد کنید"
    } else {
        delete errors.meetingOrder
    }

    if (!date) {
        errors.date = "لطفا روز برگزاری را انتخاب کنید"
    } else {
        delete errors.date
    }

    if (!time) {
        errors.time = "لطفا ساعت برگزاری را انتخاب کنید"
    } else {
        delete errors.time
    }

    if (invitedPeople == "") {
        errors.invitedPeople = "لطفا نفرات دعوت شده را انتخاب کنید"
    } else {
        delete errors.invitedPeople
    }

    return errors;
}